import { render, staticRenderFns } from "./DxFormProduct.vue?vue&type=template&id=d1e89b90&"
import script from "./DxFormProduct.vue?vue&type=script&lang=js&"
export * from "./DxFormProduct.vue?vue&type=script&lang=js&"
import style0 from "./DxFormProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports